module.exports = __webpack_public_path__ + "static/img/dk.eb1416e0.svg";